import { useState } from "react";
import { CHIP_STYLES } from "../../constants/data";
import { calcDelay } from "../../utils/vehicleUtils";
import HGSection from "../ui/HGSection";
import VehicleDetailModal from "../modals/VehicleDetailModal";
import FahrzeugTrackerModal from "../modals/FahrzeugTrackerModal";

export default function RightPanel({ vehicles, selectedVehicle, projectColorMap = {}, onSelectVehicle, onGrantHG }) {
  const [openHG, setOpenHG] = useState(null);
  const [detailVehicleId, setDetailVehicleId] = useState(null);
  const [hgFlowOpen, setHgFlowOpen] = useState(false);

  // Always derive live vehicle objects from the vehicles array
  const detailVehicle = vehicles.find(v => v.id === detailVehicleId) ?? null;

  function toggleHG(hg) {
    setOpenHG(prev => (prev === hg ? null : hg));
  }

  function handleCardClick(v) {
    if (selectedVehicle && selectedVehicle.id === v.id) {
      setDetailVehicleId(v.id);
    } else {
      onSelectVehicle(v);
    }
  }

  // ── helpers ──────────────────────────────────────────────────────────────────
  // Each row includes the vehicle id as the last element (hidden from display via grantColIndex)
  // Grant column is always the second-to-last visible column; id is the very last element.

  const hg0Vehicles = vehicles.filter(v => v.hgStatus === "HG0");
  const hg0Rows = hg0Vehicles.map(v => [
    v.vehicleNumber || v.vehicleName || "–",
    v.hgStatus,
    v.desiredDate || "–",
    calcDelay(v.desiredDate),
    "GRANT",   // grant column placeholder
  ]);

  const hg1Vehicles = vehicles.filter(v => v.hgStatus === "HG1");
  const hg1Rows = hg1Vehicles.map(v => [
    v.vehicleNumber || "–",
    v.vehicleNumberOld || "–",
    v.desiredDate || "–",
    calcDelay(v.desiredDate),
    "GRANT",
  ]);

  const hg2Vehicles = vehicles.filter(v => v.hgStatus === "HG2");
  const hg2Rows = hg2Vehicles.map(v => [
    v.vehicleNumber || "–",
    v.desiredDate || "–",
    v.hgStatus,
    v.desiredDate || "–",
    calcDelay(v.desiredDate),
    "GRANT",
  ]);

  const hg3Vehicles = vehicles.filter(v => v.hgStatus === "HG3");
  const hg3Rows = hg3Vehicles.map(v => [
    v.vehicleNumber || "–",
    v.hgStatus,
    v.desiredDate || "–",
    v.desiredDate || "–",
    calcDelay(v.desiredDate),
    "GRANT",
  ]);

  const hg4Vehicles = vehicles.filter(v => v.hgStatus === "HG4");
  const hg4Rows = hg4Vehicles.map(v => [
    v.vehicleNumber || "–",
    v.hgStatus,
    v.desiredDate || "–",
    calcDelay(v.desiredDate),
    "GRANT",
  ]);
  const HG_ORDER = ["HG0","HG1","HG2","HG3","HG4","HG5","HG6"];

  // Grant handler: advance vehicle at rowIndex in the given filtered list
  function makeGrantHandler(filteredList) {
    return (rowIndex) => onGrantHG && onGrantHG(filteredList[rowIndex].id);
  }

  return (
    <div style={{ width: 400, borderLeft: "1px solid #dde3e8", background: "white", display: "flex", flexDirection: "column", padding: 14, gap: 12, overflowY: "auto", flexShrink: 0 }}>

      {/* Header */}
      <div style={{ fontSize: 12, fontWeight: 600, paddingBottom: 10, borderBottom: "1px solid #e0e0e0" }}>
        Line-Off Target: Monday, March 16, 2026
      </div>

      {/* ── Selected vehicle card ── */}      {selectedVehicle && (() => {
        const currentIdx = HG_ORDER.indexOf(selectedVehicle.hgStatus || "HG0");        const projektname = selectedVehicle.projektname || selectedVehicle.projectName;
        const projectColor = projectColorMap[projektname] || "#cce5ff";
        return (          <div
            onClick={() => handleCardClick(selectedVehicle)}
            title="Click again for details"
            style={{
              border: "1.5px solid #333", borderRadius: 8, padding: "10px 13px",
              background: "white", cursor: "pointer", display: "flex", flexDirection: "column", gap: 8,
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            }}
          >
            {/* Top row: name + badge */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                {/* colour dot still reflects the project colour */}
                <span style={{ width: 9, height: 9, borderRadius: "50%", background: projectColor, flexShrink: 0 }} />
                <span style={{ fontSize: 13, fontWeight: 700, color: "#1a1a2e" }}>
                  {selectedVehicle.vehicleNumber || selectedVehicle.fahrzeugnummer || selectedVehicle.label || "Vehicle"}
                </span>
              </div>
              <span style={{ fontSize: 10, background: "#1e6b6b", color: "white", padding: "2px 7px", borderRadius: 10, fontWeight: 600 }}>
                {selectedVehicle.hgStatus || "–"}
              </span>
            </div>

            {/* HG progress bar */}
            <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
              {HG_ORDER.map((hg, i) => {
                const isDone    = i < currentIdx;
                const isCurrent = i === currentIdx;
                return (
                  <div key={hg} style={{ display: "flex", alignItems: "center", flex: 1, flexDirection: "column", gap: 2 }}>
                    <div style={{
                      width: "100%", height: isCurrent ? 6 : 4, borderRadius: 3,
                      background: isDone ? "#4caf50" : isCurrent ? "#e67e22" : "#d0dde0",
                      transition: "background 0.2s",
                    }} />
                    <span style={{
                      fontSize: 8, fontWeight: isCurrent ? 700 : 400,
                      color: isDone ? "#388e3c" : isCurrent ? "#e67e22" : "#aaa",
                    }}>{hg}</span>
                  </div>
                );
              })}
            </div>            {/* Details row */}
            <div style={{ display: "flex", gap: 14, fontSize: 10, color: "#555", flexWrap: "wrap" }}>
              {projektname                                                                           && <span>📁 {projektname}</span>}
              {(selectedVehicle.desiredDate || selectedVehicle.ba_soll)                            && <span>📅 {selectedVehicle.desiredDate || selectedVehicle.ba_soll}</span>}
              {(selectedVehicle.vehicleResponsible || selectedVehicle.fahrzeugverantwortlicher)    && <span>👤 {selectedVehicle.vehicleResponsible || selectedVehicle.fahrzeugverantwortlicher}</span>}
            </div>
            <div style={{ fontSize: 10, color: "#888", textAlign: "right" }}>Click for details →</div>
          </div>
        );
      })()}

      {/* ── HG Due Dates section ── */}
      <div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 12, fontWeight: 600, marginBottom: 8 }}>
          Due Dates by HG Stage
          <button
            onClick={() => setHgFlowOpen(true)}
            title="View HG stage flow"
            style={{ width: 18, height: 18, borderRadius: "50%", border: "1.5px solid #1e6b6b", color: "#1e6b6b", background: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
          >i</button>
        </div>

        <HGSection
          label="HG0: New Vehicles (VSC Approval Pending)"
          headers={["Vehicle No.", "Status", "Line-Off Target", "Delay [d]", "Grant HG1?"]}
          rows={hg0Rows} open={openHG === "HG0"} onToggle={() => toggleHG("HG0")}
          grantColIndex={4} onGrant={makeGrantHandler(hg0Vehicles)}
        />
        <HGSection
          label="HG1: VSC Approved (Order Pending)"
          headers={["Vehicle No. New", "Vehicle No. Old", "Line-Off Target", "Delay [d]", "Grant HG2?"]}
          rows={hg1Rows} open={openHG === "HG1"} onToggle={() => toggleHG("HG1")}
          grantColIndex={4} onGrant={makeGrantHandler(hg1Vehicles)}
        />
        <HGSection
          label="HG2: Order Placed (Validation Pending)"
          headers={["Vehicle No.", "Line-Off Target", "Status", "Spec. Target", "Delay [d]", "Grant HG3?"]}
          rows={hg2Rows} open={openHG === "HG2"} onToggle={() => toggleHG("HG2")}
          grantColIndex={5} onGrant={makeGrantHandler(hg2Vehicles)}
        />
        <HGSection
          label="HG3: Validation Done (Spec. Release Pending)"
          headers={["Vehicle No.", "Status", "Line-Off Target", "Spec. Target", "Delay [d]", "Grant HG4?"]}
          rows={hg3Rows} open={openHG === "HG3"} onToggle={() => toggleHG("HG3")}
          grantColIndex={5} onGrant={makeGrantHandler(hg3Vehicles)}
        />
        <HGSection
          label="HG4: Spec. Release Granted (Line-Off Pending)"
          headers={["FZG Nr.", "Status", "BA Soll", "Verzug vs. BA Soll [d]", "Grant HG5?"]}
          rows={hg4Rows} open={openHG === "HG4"} onToggle={() => toggleHG("HG4")}
          grantColIndex={4} onGrant={makeGrantHandler(hg4Vehicles)}
        />
      </div>      {/* ── Projects ── */}
      {(() => {
        const uniqueProjects = [...new Map(
          vehicles
            .filter(v => v.projektname || v.projectName)
            .map(v => {
              const name = v.projektname || v.projectName;
              const num  = v.projektnummer || v.projectNumber || "";
              return [name, { name, num }];
            })
        ).values()].sort((a, b) => a.name.localeCompare(b.name));

        if (uniqueProjects.length === 0) return null;

        return (
          <div>
            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8, paddingTop: 4, borderTop: "1px solid #e0e0e0" }}>
              Projects ({uniqueProjects.length})
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              {uniqueProjects.map(({ name, num }) => (
                <div key={name} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 11, color: "#444" }}>
                  <div style={{ width: 20, height: 12, borderRadius: 2, flexShrink: 0, background: projectColorMap[name] || "#cce5ff" }} />
                  <span style={{ fontWeight: 600, color: "#222" }}>{name}</span>
                  {num && <span style={{ color: "#888", fontSize: 10 }}>({num})</span>}
                </div>
              ))}
            </div>
          </div>
        );
      })()}

      {/* Vehicle detail modal */}      {detailVehicle && (
        <VehicleDetailModal vehicle={detailVehicle} onClose={() => setDetailVehicleId(null)} />
      )}

      {/* General HG flow modal — opened by ⓘ button */}
      {hgFlowOpen && (
        <FahrzeugTrackerModal onClose={() => setHgFlowOpen(false)} />
      )}
    </div>
  );
}
